// One list per AI scope, shared by every surface of that scope so they never
// drift apart; `question` is the chip's label and what a click sends to the
// agent.
export const POPULAR_AI_QUESTIONS = [
  { question: 'How do predictions work?' },
  { question: 'How do I earn SAN?' },
  { question: 'Why is my prediction pending?' },
  { question: 'Is this gambling?' },
] as const;

export const ACTIVITY_AI_QUESTIONS = [
  { question: 'Which wallet realized the highest profit in the last 24h?' },
  { question: 'Are whales currently accumulating or dumping this asset?' },
  {
    question:
      'Which price level holds the highest risk for massive liquidations?',
  },
] as const;

export const MARKET_AI_QUESTIONS = [
  { question: 'Summarize this KOL call' },
  { question: 'What factors could invalidate this call?' },
  { question: 'Help me write a thesis against this' },
] as const;
